import { render } from "./checkbox.vue?vue&type=template&id=9cba5132"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cba5132"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cba5132', __exports__)) {
    console.log('reload')
    api.reload('9cba5132', __exports__)
  }
  
  module.hot.accept("./checkbox.vue?vue&type=template&id=9cba5132", () => {
    console.log('re-render')
    api.rerender('9cba5132', render)
  })

}


export default __exports__